import React from "react";
import SystemReports from "../superadmin/SystemReports";

function ControllerSystemReportsPage() {
  return <SystemReports />;
}

export default ControllerSystemReportsPage;
